import React from "react";
import './scss/pagination.scss';

const Pagination = (props) => {

  const pagination = [];
  const paginationLimit = 8;

  // Add first page link if not on first page.
  if ((props.pagination.page + 1) > 1) {
    pagination.push(
        <div key='-2' className='pagination-link pagination-arrow first-page'>
          <a data-page={0} href='?page=1'>First</a>
        </div>
    );
    pagination.push(
        <div key='-1' className='pagination-link pagination-arrow previous-page'>
          <a data-page={props.pagination.page - 1} href={`?page=${props.pagination.page + 1 - 1}`}>Previous</a>
        </div>
    );
  }

  // Add numbered pages.
  for (let i = 0; i < props.pagination.pages; i++) {
    if (i == (props.pagination.page)) {
      pagination.push(
        <div key={i} className={`pagination-link current-page page-${i}`}>
          {i + 1}
        </div>
      );
    }
    else {
      if (i > (props.pagination.page + paginationLimit) || i < (props.pagination.page - paginationLimit)) {
      let ellipsis = (i == 0 || i == props.pagination.pages - 1) ? 'ellipsis' : '';
        pagination.push(
          <div key={i} className={`pagination-link pagination-ellipsis page-${i} ${ellipsis}`}>
            ...
          </div>
        );
        continue;
      }
      pagination.push(
        <div key={i} className={`pagination-link page-${i}`}>
          <a data-page={i} href={`?page=${i + 1}`}>
            {i + 1}
          </a>
        </div>
      );
    }
  }

  // Add last page link if not on last page.
  if ((props.pagination.page + 1) < props.pagination.pages) {
    pagination.push(
        <div key='-4' className={`pagination-link pagination-arrow next-page`}>
          <a data-page={props.pagination.page + 1} href={`?page=${props.pagination.page + 1 + 1}`}>Next</a>
        </div>
    );
    pagination.push(
        <div key='-5' className={`pagination-link pagination-arrow last-page`}>
          <a data-page={props.pagination.pages - 1} href={`?page=${props.pagination.pages}`}>Last</a>
        </div>
    );
  }

  const handlePagination = (e) => {
    e.preventDefault();
    props.scrollTop();
    if (e.target.attributes['data-page']) {
      props.setFilters({...props.filters, page: e.target.attributes['data-page'].value});
    }
  };

  return (
    <div className='cp-pagination grid-cell--justify-center' onClick={handlePagination}>
      {pagination}
    </div>
  );

};

export default Pagination;